import React, { Fragment } from 'react';
import { node } from 'prop-types';
import { privateSaleShape } from 'shapes';
import { PrivateSaleLocker } from './components';

const PrivateSalePage = ({ sale, children }) => {
    return (
        <Fragment>
            <PrivateSaleLocker sale={sale} />
            {children}
        </Fragment>
    );
};
PrivateSalePage.propTypes = {
    sale: privateSaleShape.isRequired,
    children: node.isRequired,
};
export default PrivateSalePage;
